import React from 'react';
import { CTAButton } from './CTAButton';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full bg-brand-cream pt-12 pb-16 px-4 md:pt-20 md:pb-24" data-id="element-67">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-68">
        <span className="bg-brand-wine/10 text-brand-wine px-4 py-1 rounded-full text-sm font-bold tracking-widest uppercase mb-6 border border-brand-wine/20" data-id="element-69">
          Ebook Digital
        </span>

        <h1 className="font-serif text-5xl md:text-7xl font-black text-brand-wine mb-6 leading-tight" data-id="element-70">
          MERECES MÁS
        </h1>

        <h2 className="text-xl md:text-2xl font-medium text-gray-800 mb-10 max-w-2xl leading-relaxed" data-id="element-71">
          120 reflexiones para volver a elegirte, respetarte y amarte como
          mereces.
        </h2>

        <a href="https://colorpack.store/cart/45914855866566:1" className="block w-full max-w-md mx-auto mb-10 hover:scale-105 transition-transform duration-300" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/dvv8ZyRNcGRQy2iwuS6pCc/MERECES_MAS_MOCKUP.png" alt="Libro Mereces Más" className="w-full h-auto drop-shadow-2xl rounded-sm" data-id="element-73" />
        </a>

        <div className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto space-y-6" data-id="element-74">
          <p className="font-medium" data-id="element-75">
            ¿Sientes que has dado demasiado por personas que nunca supieron
            valorarte?
          </p>
          <p data-id="element-76">
            Este libro te ayudará a recuperar tu autoestima, dejar de
            conformarte con migajas emocionales y convertirte nuevamente en la
            persona más importante de tu vida.
          </p>
        </div>

        <div className="flex flex-col items-start text-left bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-10 max-w-lg w-full mx-auto" data-id="element-77">
          <ul className="space-y-4 w-full" data-id="element-78">
            {['Acceso inmediato', 'Lectura fácil y transformadora', 'Incluye 5 bonos exclusivos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium text-gray-800" data-id="element-79">
                <div className="bg-green-100 p-1 rounded-full" data-id="element-80">
                  <Check className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-81" />
                </div>
                {item}
              </li>)}
          </ul>
        </div>

        <CTAButton data-id="element-82" />
      </div>
    </section>;
}